module.exports = __webpack_public_path__ + "static/pid-ug-21-en-signaturebutton-faf8bd8d3e36f43ee2583cac390c0977.png";